import { useCallback, useState } from 'react';

/** Index of the photo shown in a viewer of `count` photos, kept within its bounds. */
export const usePhotoNavigation = (count: number, initialIndex = 0) => {
  const clamp = useCallback(
    (value: number) => Math.min(Math.max(value, 0), Math.max(count - 1, 0)),
    [count]
  );
  const [rawIndex, setIndex] = useState(initialIndex);
  // Clamped on read too, so a shrinking `count` never leaves the index out of range
  const index = clamp(rawIndex);

  const next = useCallback(() => setIndex((value) => clamp(value + 1)), [clamp]);
  const prev = useCallback(() => setIndex((value) => clamp(value - 1)), [clamp]);

  return { index, next, prev, hasNext: index < count - 1, hasPrev: index > 0 };
};
